import React from 'react';
import style from './style';
import EAColorIcon from '../../../../../../components/common/EAColorIcon';
import i18next from 'i18next';

const Header = ({ tp }) => {
  const { classes } = style();

  return (
    <div className={classes.header}>
      <EAColorIcon icon={'context/contextTree/addTiersAttributes'} />
      <div className={classes.title}>
        {i18next.t('context.addTiers.addTiersSuivi')}
      </div>
      {tp && (
        <div className={classes.tpResultInfos}>
          <div className={classes.tpName}>{tp.name}</div>
          <div className={classes.tpActivity}>{tp.activityLabel}</div>
        </div>
      )}
    </div>
  );
};

export default Header;
